import { render, staticRenderFns } from "./point-label.vue?vue&type=template&id=2e333e01&scoped=true"
import script from "./point-label.vue?vue&type=script&lang=js"
export * from "./point-label.vue?vue&type=script&lang=js"
import style0 from "./point-label.vue?vue&type=style&index=0&id=2e333e01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e333e01",
  null
  
)

export default component.exports